import { render, staticRenderFns } from "./Deconvolution.vue?vue&type=template&id=004573fa&scoped=true"
import script from "./Deconvolution.vue?vue&type=script&lang=js"
export * from "./Deconvolution.vue?vue&type=script&lang=js"
import style0 from "./Deconvolution.vue?vue&type=style&index=0&id=004573fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004573fa",
  null
  
)

export default component.exports